import api from './api';

export interface SearchResultItem {
  id: number;
  title: string;
  subtitle?: string;
  link: string;
  type: string;
}

export interface SearchResult {
  module: string;
  items: SearchResultItem[];
  total: number;
}

export interface SearchResponse {
  [module: string]: SearchResult;
}

export const search = async (
  query: string,
  modules?: string[],
  limit: number = 10
): Promise<SearchResponse> => {
  if (!query || query.trim() === '') {
    return {};
  }

  const params = new URLSearchParams();
  params.append('q', query.trim());
  if (modules && modules.length > 0) {
    params.append('modules', modules.join(','));
  }
  if (limit) {
    params.append('limit', String(limit));
  }

  const response = await api.get(`/search?${params.toString()}`);
  return response.data;
};

// Cache recent searches in localStorage
const RECENT_SEARCHES_KEY = 'recent_searches';
const MAX_RECENT_SEARCHES = 10;

export const getRecentSearches = (): string[] => {
  try {
    const recent = localStorage.getItem(RECENT_SEARCHES_KEY);
    return recent ? JSON.parse(recent) : [];
  } catch {
    return [];
  }
};

export const addRecentSearch = (query: string): void => {
  if (!query || query.trim() === '') return;

  try {
    const recent = getRecentSearches();
    const trimmedQuery = query.trim();
    
    // Remove if already exists
    const filtered = recent.filter((q) => q !== trimmedQuery);
    
    // Add to beginning
    filtered.unshift(trimmedQuery);
    
    // Keep only last MAX_RECENT_SEARCHES
    const limited = filtered.slice(0, MAX_RECENT_SEARCHES);
    
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(limited));
  } catch (error) {
    console.error('Failed to save recent search:', error);
  }
};

export const clearRecentSearches = (): void => {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch (error) {
    console.error('Failed to clear recent searches:', error);
  }
};
